// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as LbUtils from "./LbUtils.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as LbRanked from "./LbRanked.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as LbPlayerSearch from "./LbPlayerSearch.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import CopyToClipboard from "copy-to-clipboard";

var init = {
  contents: undefined
};

function LbCustom(Props) {
  var data = Props.data;
  var match = React.useState(function () {
        return false;
      });
  var usePatchStats = match[0];
  var set = TftSet.use(undefined);
  React.useEffect((function () {
          var url = init.contents;
          if (url !== undefined) {
            CopyToClipboard("https://tactics.tools" + url);
            var cb = SnackbarService.sub.contents;
            if (cb !== undefined) {
              Curry._1(cb, "Leaderboard created and link copied to clipboard");
            }
            init.contents = undefined;
          }
          
        }), []);
  var title = data.title;
  var data$1 = React.useMemo((function () {
          return Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(data.data, (function (d1, d2) {
                            return Belt_Option.mapWithDefault(d2.rank, 0, (function (param) {
                                          return LpChartUtils.divisionToBase(param[0], set) + param[1] | 0;
                                        })) - Belt_Option.mapWithDefault(d1.rank, 0, (function (param) {
                                          return LpChartUtils.divisionToBase(param[0], set) + param[1] | 0;
                                        })) | 0;
                          })), (function (idx, d) {
                        return {
                                num: idx,
                                region: d.region,
                                playerName: d.playerName,
                                tag: d.tag,
                                patch: d.patch,
                                companionId: d.companionId,
                                rank: d.rank,
                                games: d.games,
                                top4: d.top4,
                                won: d.won,
                                mostPlayedUnits: d.mostPlayedUnits,
                                prePatchRank: d.prePatchRank,
                                patchGames: d.patchGames,
                                patchTop4: d.patchTop4,
                                patchWon: d.patchWon,
                                patchMostPlayedUnits: d.patchMostPlayedUnits
                              };
                      }));
        }), [data]);
  var renderElements = LbUtils.useRenderElements(undefined);
  var data$2 = React.useMemo((function () {
          return Belt_Array.slice(data$1, 0, renderElements);
        }), [
        data$1,
        renderElements
      ]);
  var keyFn = React.useCallback((function (d) {
          return d.region + " " + d.playerName;
        }), []);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(LbPlayerSearch.make, {}), React.createElement(ContentSection.make, {
                  className: "font-montserrat font-medium md:w-[920px]",
                  children: React.createElement("div", {
                        className: usePatchStats ? "lb-patch-stats" : "lb-season-stats"
                      }, React.createElement(StatsTable2.make, {
                            montserratHeader: true,
                            size: "lg",
                            cols: LbRanked.cols,
                            data: data$2,
                            context: undefined,
                            extraStickyHeader: React.createElement("div", {
                                  className: "h-12 flex items-center justify-between pt-1 pr-6 text-center font-semibold"
                                }, React.createElement("div", {
                                      className: "pl-3 font-montserrat font-semibold"
                                    }, title), React.createElement(LbUtils.PatchStatsToggle.make, {
                                      usePatchStats: usePatchStats,
                                      setUsePatchStats: match[1]
                                    })),
                            keyFn: keyFn,
                            stickyColCount: 2,
                            top: "t48"
                          })),
                  noPadding: true
                }));
}

var make = LbCustom;

export {
  init ,
  make ,
  
}
/* react Not a pure module */
